import { User, UserType } from "../entities/User";

const AreaLibraryPolicy = {
  canAccess(user: User) {
    return user.type !== UserType.Unknown;
  }
}

export default AreaLibraryPolicy;
